module.exports = __webpack_public_path__ + "static/img/grac-oidd-competition-proposal02.cd1921c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/grac-oidd-competition-proposal02.jpg
// module id = ydo7
// module chunks = 0